import { LocationModel } from "src/modules/location/types/Location";
import { ObjectItem } from "src/utils/object";

export type StationStatus =
    | "pending" /** no connection recorded */
    | "available" /** currently connected to Central System and status Available */
    | "unavailable" /** currently connected to Central System and status Unavailable */
    | "reboot-required" /** currently connected to Central System, but configuration was modified and reboot is required to apply these changes. */
    | "offline" /** lost connection */
    | "error"; /** currently connected to Central System and status Unavailable or Faulted */

export const stationStatusesList = [
    "pending",
    "available",
    "unavailable",
    "reboot-required",
    "offline",
    "error",
];

export enum StationEvseAvailabilityStatus {
    /** Request has been accepted and will be executed. */
    ACCEPTED = "Accepted",
    /** Request has not been accepted and will not be executed. */
    REJECTED = "Rejected",
    /** Request has been accepted and will be executed when transaction(s) in progress have finished. */
    SCHEDULED = "Scheduled",
}

export enum StationConfigurationStatus {
    /** Configuration key supported and setting has been changed. */
    ACCEPTED = "Accepted",
    /** Configuration key supported, but setting could not be changed. */
    REJECTED = "Rejected",
    /**
     * Configuration key supported and setting has been changed,
     * but change will be available after reboot (Charge Point will not reboot itself).
     */
    REBOOT_REQUIRED = "RebootRequired",
    /** Configuration key is not supported. */
    NOT_SUPPORTED = "NotSupported",
}

export type StationEvseStatus =
    | "pending"
    | "available"
    | "preparing"
    | "charging"
    | "suspended"
    | "finishing"
    | "reserved"
    | "unavailable"
    | "error";

export const stationEvseStatusesList = [
    "pending",
    "available",
    "preparing",
    "charging",
    "suspended",
    "finishing",
    "reserved",
    "unavailable",
    "error",
];

export interface StationEvseModel {
    id: string;
    maxPower: number;
    connectorId: number;
    status: StationEvseStatus;
    outlets: {
        connector: string;
        hasCable: boolean;
    }[];
}

export enum StationType {
    Public = "public",
    Private = "private",
    Home = "fleet",
}

export interface StationModel {
    operators: ObjectItem<string>[];
    employee: ObjectItem<string>[];
    tariff: ObjectItem<string>;
    id: string;
    identifier: string;
    type: StationType;
    hasAccess: boolean;
    protocolVersion: string;
    status: StationStatus;
    location: LocationModel;
    simCard: ObjectItem<number>;
    evses: StationEvseModel[];
    latitude: number;
    longitude: number;
    // model: string;
    // syncEipa: boolean;
}

export interface StationConfiguration {
    lastRefresh: string;
    values: { key: string; value: string; readOnly: boolean }[];
}

export interface StationInfoModel {
    lastHeartbeatAt: string;
    lastBootAt: string;
    bootInfo: {
        chargePointVendor: string;
        chargePointModel: string;
        chargePointSerialNumber: string;
        firmwareVersion: string;
        iccid: string;
        imsi: string;
        meterType: string;
        meterSerialNumber: string;
    };
}

export interface StationSummary {
    stations: {
        available: number;
        error: number;
        offline: number;
        pending: number;
        rebootRequired: number;
        total: number;
        unavailable: number;
    };
    evses: {
        available: number;
        charging: number;
        error: number;
        finishing: number;
        pending: number;
        preparing: number;
        reserved: number;
        suspendedEv: number;
        suspendedEvse: number;
        total: number;
        unavailable: number;
    };
}
